import { render } from "./CollectionDetailedSearchBooks.vue?vue&type=template&id=ec420656&scoped=true&ts=true"
import script from "./CollectionDetailedSearchBooks.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchBooks.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchBooks.vue?vue&type=style&index=0&id=ec420656&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec420656"]])

export default __exports__